//  Link media
require.context('../media/', true, /^\.\/.*\.*/);

//  Styles
import '../styles/styles.scss';

// JS
import $ from 'jquery';
import InView from './proj/inview';
import magnificPopup from './proj/magnificpopup';
import { Howl, Howler } from 'howler';
// import Plyr from './proj/plyr';

import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


let Site;
let breakpointSite = 767;
let horizontalAnimation;

(function ($) {
	'use strict';

	$(window).on("blur", function () {
		$('.label-sound').html('Sound off');
		$('.toogleMute').removeClass('is-playing');
		Howler.mute(true);
	});

	Site = {
		/**
		 * initialize prototype
		 *
		 */
		init: function (elt) {
			var self = this;

			$('#sada').addClass('page-ready');
			self.mobileNav();

			if ($('.page-about').length > 0) {
				self.inviewAnimation();
			}
			else {
				// setTimeout(function(){
				self.videoUnmute();
				self.videoLightbox();
				self.selectObject();
				self.asideNav();
				self.pinElements();
				self.toogleMuteAll();
				self.hideNav();
				self.inviewAnimation();
				self.inviewLazy();

				// }, 500);

				// default settings
				ScrollTrigger.defaults({
					start: "top top",
					markers: false,
				});

				$('header .logo').on('click', function (e) {
					e.preventDefault();
					e.stopPropagation();
					window.scrollTo({ top: 0, behavior: 'smooth' });
				});

			}
		},

		// Howler mute all
		toogleMuteAll: function () {
			var self = this;

			let hasActivatedAudio = false;

			$('.toogleMute').on('click', function (e) {
				e.preventDefault();

				if (!hasActivatedAudio) {
					hasActivatedAudio = true;
					self.backgroundSounds();
					$('.js-audio-on').hide();
				}

				let label;

				if ($(this).hasClass('is-playing')) {
					$(this).removeClass('is-playing');
					Howler.mute(true);
					label = 'Sound off';
				}
				else {
					$(this).addClass('is-playing');
					Howler.mute(false);
					label = 'Sound on';
				}
				$('.label-sound').html(label);
			});
		},

		hideNav: function () {
			ScrollTrigger.create({
				trigger: $('.donate'),
				onEnter: function () {
					$('aside').addClass('is-hidden');
				},
				onLeaveBack: function () {
					$('aside').removeClass('is-hidden');
				},
				id: 'hide-nav',
				start: "top bottom"
			});
		},

		backgroundSounds: function () {
			// Setup the new Howl.
			let sound_chp = []

			Howler.autoUnlock = true;
			Howler.html5PoolSize = 10;

			const vol_max = 0.5;


			sound_chp['intro'] = new Howl({
				src: ['media/audio/ambience/INTRO.mp3'],
				autoplay: false,
				loop: true,
				volume: 0.5,
				html5: true,
				onload: function () {
					// console.log('===  main.js [86] sound 1 loaded ===' );
					// sound_chp_play[0] = sound_chp[0].play();
				},
				onplayerror: function () {
					sound_chp['intro'].once('unlock', function () {
						sound_chp['intro'].play();
					});
				}
			});

			$('.splash-slides').on('inview', function (event, isInView) {
				if (isInView) {
					if (!$(this).hasClass('played-once')) {
						// $(this).addClass('played-once');
						sound_chp['intro'].seek(0);
						sound_chp['intro'].play();
						// sound_chp[currentValue[0]].fade(0, vol_max, 1000);
					}
				}
				else {
					if (!$(this).hasClass('ended-once')) {
						// $(this).addClass('ended-once');
						sound_chp['intro'].fade(vol_max, 0, 500);
					}
				}
			});



			sound_chp[0] = new Howl({
				src: ['media/audio/ambience/INTRO-AND-END-PAGES-ONE-SHOT-LONG.mp3'],
				autoplay: false,
				loop: false,
				volume: 0.5,
				html5: true,
				onload: function () {
					// console.log('===  main.js [86] sound 1 loaded ===' );
					// sound_chp_play[0] = sound_chp[0].play();
				},
				onplayerror: function () {
					// sound_chp[0].once('unlock', function() {
					// sound_chp[0].play();
					// });
				}
			});

			$('.js-start-intro-outro').each(function () {
				ScrollTrigger.create({
					trigger: $(this),
					// markers: true,
					onEnter: function () {
						sound_chp[0].seek(0);
						sound_chp[0].volume(0.5);
						sound_chp[0].play();
						// sound_chp[0].fade(0, vol_max, 1000);
						// console.log('===  main.js [96] chp0 play onEnter ===');
					},
					onEnterBack: function () {
						sound_chp[0].fade(vol_max, 0, 1000);
						// console.log('===  main.js [96] chp0 play onEnterBack ===');
					},
					id: 'enter intro',
					start: "top 50px",
				});
			})

			$('.js-end-intro-outro').each(function () {
				ScrollTrigger.create({
					trigger: $(this),
					// markers: true,
					onEnter: function () {
						sound_chp[0].fade(vol_max, 0, 1000);
						// console.log('===  main.js [96] chp0 play onEnter ===');
					},
					onEnterBack: function () {
						sound_chp[0].seek(0);
						sound_chp[0].play();
						sound_chp[0].fade(0, vol_max, 1000);
						// console.log('===  main.js [96] chp0 play onEnterBack ===');
					},
					id: 'leave outro',
					start: "top 50px",
				});
			})


			sound_chp[1] = new Howl({
				src: ['media/audio/ambience/SADA-CHAPTER-1-V3-BACKGROUND-LOOP.mp3'],
				autoplay: true,
				loop: true,
				volume: 0,
				html5: true,
				onload: function () {
					// console.log('===  main.js [86] sound 1 loaded ===' );
					// sound_chp_play[1] = sound_chp[1].play();
				},
				onplayerror: function () {
					sound_chp[1].once('unlock', function () {
						sound_chp[1].play();
					});
				}
			});
			sound_chp[2] = new Howl({
				src: ['media/audio/ambience/SADA-CHAPTER-3-V3-MUSIC-LOOP.mp3'],
				autoplay: true,
				loop: true,
				volume: 0,
				html5: true,
				onload: function () {
					// console.log('===  main.js [86] sounds 2 loaded ===' );
					// sound_chp_play[2] = sound_chp[2].play();
				},
				onplayerror: function () {
					sound_chp[2].once('unlock', function () {
						sound_chp[2].play();
					});
				}
			});

			// ONE SHOTS SOUNDS
			let oneshots1 = [];
			oneshots1.push(['whatsapp-chime', 'media/audio/ambience/SADA-CHAPTER-1-ONE-SHOT-1-WHATSAPP-CHIME.mp3']);
			oneshots1.push(['phone-vibrate', 'media/audio/ambience/SADA-CHAPTER-1-ONE-SHOT-2-PHONE-VIBRATE.mp3']);
			oneshots1.push(['phone-type', 'media/audio/ambience/SADA-CHAPTER-1-ONE-SHOT-3-PHONE-TYPE.mp3']);
			oneshots1.push(['plane', 'media/audio/ambience/SADA-CHAPTER-1-ONE-SHOT-4-PLANE.mp3']);
			oneshots1.push(['tears', 'media/audio/ambience/SADA-CHAPTER-1-ONE-SHOT-5-TEARS.mp3']);
			oneshots1.push(['rifle', 'media/audio/ambience/SADA-CHAPTER-1-ONE-SHOT-5-RIFFLE.mp3']);
			oneshots1.push(['sing', 'media/audio/ambience/SADA-CHAPTER-1-ONE-SHOT-6-SING.mp3']);


			// CHAPTER 1
			for (var i = oneshots1.length - 1;i >= 0;i--) {

				const soundName = oneshots1[i][0];

				sound_chp[soundName] = new Howl({
					src: [oneshots1[i][1]],
					autoplay: false,
					loop: false,
					volume: 0.5,
					html5: true,
					preload: true,
					onload: function () {
						// console.log('===  main.js [86] sounds 2 loaded ===' );
					},
					onplayerror: function () {
						sound_chp[soundName].once('unlock', function () {
							sound_chp[soundName].play();
						});
					}
				});
			};

			oneshots1.forEach(function (currentValue, index, arr) {
				$('.js-one-shot-' + currentValue[0]).on('inview', function (event, isInView) {
					if (isInView) {
						if (!$(this).hasClass('played-once')) {
							$(this).addClass('played-once');
							sound_chp[currentValue[0]].seek(0);
							sound_chp[currentValue[0]].play();
							// sound_chp[currentValue[0]].fade(0, vol_max, 1000);
						}
					}
					else {
						if (!$(this).hasClass('ended-once')) {
							$(this).addClass('ended-once');
							sound_chp[currentValue[0]].fade(vol_max, 0, 500);
						}
					}
				});
			});

			// CHAPTER 3
			let oneshots3 = [];
			oneshots3.push(['image1', 'media/audio/ambience/SADA-CHAPTER-3-IMAGE-1-ONESHOT-V1.mp3']);
			oneshots3.push(['image2', 'media/audio/ambience/SADA-CHAPTER-3-IMAGE-2-ONESHOT-V1.mp3']);
			oneshots3.push(['image3', 'media/audio/ambience/SADA-CHAPTER-3-IMAGE-3-LOOP-V1.mp3']);
			oneshots3.push(['image4', 'media/audio/ambience/SADA-CHAPTER-3-IMAGE-4-ONESHOT-V1.mp3']);


			for (var i = oneshots3.length - 1;i >= 0;i--) {
				var loop_val = false;
				// var loop_val = true;
				if (oneshots3[i][0] == 'image3') {
					loop_val = true;
				}

				const soundName = oneshots3[i][0];
				sound_chp[oneshots3[i][0]] = new Howl({
					src: [oneshots3[i][1]],
					autoplay: false,
					loop: loop_val,
					volume: 0.5,
					html5: true,
					onload: function () {
						// console.log('===  main.js [86] sounds 2 loaded ===' );
					},
					onplayerror: function () {
						sound_chp[soundName].once('unlock', function () {
							sound_chp[soundName].play();
						});
					}
				});

			};

			oneshots3.forEach(function (currentValue, index, arr) {
				$('.js-one-shot-' + currentValue[0]).find('video').on('inview', function (event, isInView) {
					if (isInView) {
						if (!$(this).hasClass('played-once')) {
							$(this).addClass('played-once');
							sound_chp[currentValue[0]].seek(0);
							sound_chp[currentValue[0]].play();
							// sound_chp[currentValue[0]].fade(0, vol_max, 1000);
						}
					}
					else {
						sound_chp[currentValue[0]].fade(vol_max, 0, 500);
					}
				});
				// var $elt = $('.js-one-shot-'+currentValue[0]).find('video')

				// ScrollTrigger.create({
				// 	trigger: $elt,
				// 	start: "top center",
				// 	onUpdate: self => {
				// 		console.log("direction:", self.direction) 
				// 		if (ScrollTrigger.isInViewport($elt, 0.4)) {
				// 			if (!$(this).hasClass('played-once')) {
				// 				// $(this).addClass('played-once');
				// 				sound_chp[currentValue[0]].play();
				// 				sound_chp[currentValue[0]].fade(0, vol_max, 1000);
				// 			}
				// 		} else {
				// 			sound_chp[currentValue[0]].fade(vol_max, 0, 500);
				// 		}

				// 	}
				// });

			});


			ScrollTrigger.create({
				trigger: $('.js-playSound1'),
				// markers: true,
				onEnter: function () {
					sound_chp[1].seek(0);
					sound_chp[1].fade(0, vol_max, 1000);
					// console.log('===  main.js [96] chp1 play onEnter ===');
				},
				onEnterBack: function () {
					sound_chp[1].fade(0, vol_max, 1000);
					// console.log('===  main.js [96] chp1 play onEnterBack ===');
				},
				onLeave: function () {
					sound_chp[1].fade(vol_max, 0, 1000);
					// console.log('===  main.js [96] chp1 pause onLeave ===');
				},
				onLeaveBack: function () {
					sound_chp[1].fade(vol_max, 0, 1000);
					// console.log('===  main.js [96] chp1 pause onLeaveBack ===');
				},
				id: 'chp1',
				start: "top top",
				end: "bottom 50%"
			});

			var containerS3 = ScrollTrigger.create({
				trigger: $('.js-playSound3'),
				// markers: true,
				onEnter: function () {
					sound_chp[2].seek(0);
					sound_chp[2].fade(0, vol_max, 1000);
					// console.log('===  main.js [96] chp3 play onEnter ===');
				},
				onEnterBack: function () {
					sound_chp[2].fade(0, vol_max, 1000);
					// console.log('===  main.js [96] chp3 play onEnterBack ===');
				},
				onLeave: function () {
					sound_chp[2].fade(vol_max, 0, 1000);
					// console.log('===  main.js [96] chp3 pause onLeave ===');
				},
				onLeaveBack: function () {
					sound_chp[2].fade(vol_max, 0, 1000);
					// console.log('===  main.js [96] chp3 pause onLeaveBack ===');
				},
				id: 'chp3',
				start: "top top",
				end: "bottom 90%"
			});

		},

		mobileNav: function () {
			$('.js-main-menu-toggle').on('click', function () {
				$('.js-main-menu-toggle, .mobile-menu').toggleClass('is-active');
			});
		},
		asideNav: function () {
			$('.js-chapter-title').each(function (i) {
				var title = $(this).attr('data-title');
				var id = $(this).attr('id');
				$('aside nav').find('ul').append('<li class="chp' + parseInt(i + 1) + '"><a href="#' + id + '"><span>' + title + '</span> <i></i></a></li>');
			});
		},

		selectObject: function () {
			var self = this;
			$('.js-read-object').on('click', function () {

				// mute sound on object audio
				if ($('.toogleMute').hasClass('is-playing')) {
					$('.toogleMute').attr('data-is-playing', 'yes');
					$('.toogleMute').trigger('click');
				}
				else {
					$('.toogleMute').attr('data-is-playing', 'no');
				}


				if ($(this).hasClass('is-active')) {
					$('.js-close-object').trigger('click');
					$('.chapter-objects__instructions').addClass('is-visible');
					$('.chapter-objects__story').removeClass('is-story-open');
				}
				else {

					$('.chapter-objects__story').removeClass('is-story-open');

					setTimeout(function () {
						if (!$('.chapter-objects__story').hasClass('is-story-open')) {
							$('.chapter-objects__instructions').removeClass('is-visible');
							$('.chapter-objects__story').addClass('is-story-open');
						}
					}, 100);

					// fit lightbox on the top of the content
					if ($('body').width() <= breakpointSite) {
						const offsetTop = $(this).position().top;
						$('.chapter-objects__copy').css('top', offsetTop);
					}
					else {
						$('.chapter-objects__copy').css('top', 0);
					}

					const item = parseInt($(this).attr('data-object'));
					const $item = $('.chapter-objects__grid--item').eq(item);

					$('.chapter-objects__grid--item').addClass('is-disabled');
					// $item.removeClass('is-disabled').addClass('is-active');
					$('.chapter-objects__grid--item').find('video').each(function () {
						$(this).get(0).pause();
					});

					// if(audioPlayer) {
					// 	audioPlayer.destroy();
					// }
					$('.js-set-object-name').html($item.find('.js-object-info').attr('data-name'));
					$('.js-set-object-image').attr('src', $item.find('.js-object-info').attr('data-image'));
					$('.js-set-object-video').attr('src', $item.find('.js-object-info').attr('data-video'));
					$('.js-set-object-audio').attr('src', $item.find('.js-object-info').attr('data-audio'));
					$('.js-set-object-copy').html($item.find('.js-object-info').attr('data-copy'));

					const type = $item.find('.js-object-info').attr('data-media')
					$('.chapter-objects__story--media').addClass(type);
					$('.chapter-objects__enlarged').html('');
					$('.chapter-objects__story--media').clone().appendTo($('.chapter-objects__enlarged')).addClass('is-visible');
					if (type == "is-video") {
						$('.chapter-objects__enlarged').find('img').remove();
					}
					else {
						$('.chapter-objects__enlarged').find('video').remove();
					}
					$('.chapter-objects__enlarged').addClass('is-visible');

					//reset player
					self.resetAudioPlayer();
					$('.audio__player--playBtn').trigger('click');

					if ($(this).hasClass('is-explore-cta')) {
						// mobile 
						if ($('body').width() <= breakpointSite) {
							$('.js-close-object').trigger('click')
						}
					}
				}
			});

			self.setAudioPlayer();

			$('.js-close-object').on('click', function () {
				$('.chapter-objects__grid--item').removeClass('is-disabled');
				$('.chapter-objects__story').removeClass('is-story-open');
				$('.chapter-objects__instructions').addClass('is-visible');
				$('.chapter-objects__grid--item').find('video').each(function () {
					$(this).get(0).play();
				});
				$('.chapter-objects__enlarged').html('').removeClass('is-visible is-video is-image');
				$('.chapter-objects__story--media').removeClass('is-video is-image');
				self.resetAudioPlayer();

				if ($('.toogleMute').attr('data-is-playing') == 'yes') {
					$('.toogleMute').trigger('click');
				}
			});

			$(document).keyup(function (e) {
				if (e.key === "Escape") { // escape key maps to keycode `27`
					$('.js-close-object').eq(0).trigger('click');
				}
			});
		},

		setAudioPlayer: function () {
			$('.audio__player').each(function (e) {

				const $this = $(this);
				const $togglePlay = $this.find('.audio__player--playBtn');
				const player = $this.find('audio').get(0);
				const progressBar = $this.find('.audio__player--playhead');

				// reset 
				$('.audio__player').find('.audio__player--playhead').css('width', '0%');
				$('.audio__player').removeClass('is-playing');


				$togglePlay.on('click', function () {
					if (player.paused) {
						player.play();
						$this.addClass('is-playing');
					} else {
						player.pause();
						$this.removeClass('is-playing');
					}
				});

				// when the audio finish, reset all
				player.addEventListener("ended", function () {
					$('.audio__player').removeClass('is-playing');
					// reset to zero the progress
					progressBar.css('width', '0%');
					// time at zero
					player.currentTime = 0;
				}, true);

				// set total duration of the video
				player.addEventListener('canplaythrough', function () {
					// insert total duration into the page
					const totalLength = calculateTotalValue(player.duration);
					$this.find('.duration').html(totalLength);
				}, false);


				// calculate total length of the audio
				function calculateTotalValue(length) {
					const minutes = Math.floor(length / 60);
					let seconds_int = length - minutes * 60;
					if (seconds_int < 10) {
						seconds_int = "0" + seconds_int;
					}
					const seconds_str = seconds_int.toString();
					const seconds = seconds_str.substr(0, 2);
					const time = minutes + ':' + seconds;
					return time;
				}

				// Update the progress bar 
				function updateProgressBar() {
					// Work out how much of the media has played via the duration and currentTime parameters
					const percentage = Math.floor((100 / player.duration) * player.currentTime);
					// Update the progress bar's value
					progressBar.css('width', percentage + '%');
					// Update the progress bar's text
					const currentTime = calculateCurrentValue(player.currentTime);
					$this.find(".playhead").html(currentTime);
				}

				function calculateCurrentValue(currentTime) {
					let current_hour = parseInt(currentTime / 3600) % 24,
						current_minute = parseInt(currentTime / 60) % 60,
						current_seconds_long = currentTime % 60,
						current_seconds = current_seconds_long.toFixed(),
						current_time = (current_minute < 10 ? "" + current_minute : current_minute) + ":" + (current_seconds < 10 ? "0" + current_seconds : current_seconds);
					return current_time;
				}

				// Add a listener for the timeupdate event so we can update the progress bar
				player.addEventListener('timeupdate', updateProgressBar, false);


				$this.find('.audio__player--track').on('click', function (e) {
					if (player.src) {
						const percent = e.offsetX / this.offsetWidth;
						player.currentTime = percent * player.duration;
						// update progress bar
						progressBar.css('width', Math.floor(percent / 100) + '%');
					}
				});

			});
		},
		resetAudioPlayer: function () {
			//reset player
			$('.audio__player').find('.audio__player--playhead').css('width', '0%');
			$('.audio__player').removeClass('is-playing');
			$('.audio__player audio').get(0).pause();

		},
		pinElements: function () {

			const splashTL = gsap.timeline()
				.to($(".sada-line"), { height: '30%', duration: 0.1 })
				.to($(".splash"), { y: '-120%', duration: 0.1 })
				.to($(".sada-line"), { y: '-270%', duration: 0.1 }, "-=0.1")
				.to($(".splash-slide").eq(0), { autoAlpha: 1, duration: 0.1 })
				.to($(".js-audio-on div"), { autoAlpha: 0, duration: 0.1 }, "-=0.1")
				.call(function () { $('.js-audio-on').hide(); })
				.to($(".splash-slide").eq(0).find("p").eq(0), { y: -30, autoAlpha: 1, duration: 0.1 })
				.to($(".splash-slide").eq(0).find("p").eq(1), { y: -30, autoAlpha: 1, duration: 0.1 })
				.to($(".splash-slide").eq(0).find("p").eq(2), { y: -30, autoAlpha: 1, duration: 0.1 })
				.to($(".splash-slide").eq(1), { autoAlpha: 1, duration: 0.1 }, "+=0.2")
				.to($(".splash-slide").eq(1).find("p").eq(0), { y: -30, autoAlpha: 1, duration: 0.1 })
				.to($(".splash-slide").eq(1).find("p").eq(1), { y: -30, autoAlpha: 1, duration: 0.1 })
				.to($(".splash-slide").eq(1).find("p").eq(2), { y: -30, autoAlpha: 1, duration: 0.1 })
				.to($(".splash-slide").eq(2), { autoAlpha: 1, duration: 0.1 }, "+=0.2")
				.to($(".splash-slide").eq(2).find("p").eq(0), { y: -30, autoAlpha: 1, duration: 0.1 })
				.from($("nav li.chp1 i"), { scale: 0, duration: 0.03 })
				.to($("nav li.chp1 a span"), { opacity: '1', duration: 0.03 })
				.from($("nav li.chp2 i"), { scale: 0, duration: 0.03 })
				.to($("nav li.chp2 a span"), { opacity: '1', duration: 0.03 })
				.from($("nav li.chp3 i"), { scale: 0, duration: 0.03 })
				.to($("nav li.chp3 a span"), { opacity: '1', duration: 0.03 })
				.from($("nav li.chp4 i"), { scale: 0, duration: 0.03 })
				.to($("nav li.chp4 a span"), { opacity: '1', duration: 0.03 })
				.from($("nav li.chp5 i"), { scale: 0, duration: 0.03 })
				.to($("nav li.chp5 a span"), { opacity: '1', duration: 0.03 })
				.from($("nav li.chp6 i"), { scale: 0, duration: 0.03 })
				.to($("nav li.chp6 a span"), { opacity: '1', duration: 0.03 })
				.to($("nav li a span"), { opacity: '0', duration: 0.03 }, "+=0.2")


			ScrollTrigger.create({
				trigger: ".splash-intro",
				animation: splashTL,
				// markers: true,
				start: "top top",
				pin: true,
				scrub: 1,
				anticipatePin: 1,
				end: 5000,
			});


			// HORIZONTAL SCROLL 
			function videoRatio(videoW, videoH) {
				const w = document.documentElement.clientWidth;
				const h = document.documentElement.clientHeight;

				var ratioH = videoH * 100 / h;
				return videoW * 100 / ratioH;
			}

			let getTotalWidth = () => {
				let width = 0;

				// miscalculation in safari
				$('#textImagePinSlide .slide').each(function (index) {
					// console.log('===  main.js [687] ===', index);
					// console.log('===  main.js [687] $(this).find(.copy).outerWidth() ===', $(this).find('.copy').outerWidth());
					// let currentSlideWidth = videoRatio($(this).find('.chapter-textimage--media video').attr('width'), $(this).find('.chapter-textimage--media video').attr('height')) + $(this).find('.copy').outerWidth();
					let currentSlideWidth = videoRatio($(this).find('.chapter-textimage--media video').attr('width'), $(this).find('.chapter-textimage--media video').attr('height')) + 590;
					$(this).width(currentSlideWidth);

					// add to total
					width += currentSlideWidth;
				});
				return width;
			};

			$('#textImagePinSlide').width(getTotalWidth());


			// console.log('===  main.js [142] ===', getTotalWidth());

			if ($(window).width() > breakpointSite) {

				// const container = $('#textImagePinSlide');
				let container = document.getElementById("textImagePinSlide");
				// console.log('===  main.js [697] ===', container.width() );
				// setTimeout(function(){
				// }, 2000);

				gsap.to(container, {
					x: () => -(getTotalWidth() - document.documentElement.clientWidth),
					ease: "none",
					duration: 6,
					scrollTrigger: {
						trigger: container,
						invalidateOnRefresh: true,
						pin: true,
						anticipatePin: 1,
						scrub: true,
						end: () => "+=" + (container.offsetWidth + 2000)
					}
				})


			}
			else {
				// console.log('===  main.js [231] ===', horizontalAnimation);
				if (horizontalAnimation !== undefined) {
					// console.log('===  main.js [232] ===');
					horizontalAnimation.scrollTrigger.kill();
				}
			}

			$('.block-chat').each(function () {
				const $this = $(this).find('.line');

				ScrollTrigger.batch($this, {
					start: "top 95%",
					onEnter: batch => gsap.to($(this).find('.speechBubble'), { opacity: 1, scale: 1, stagger: { each: $this.attr('data-delay') }, overwrite: true })
				});
			})

			gsap.set($(".donate-slide p"), { y: 30, opacity: 0 });
			gsap.set($(".donate-slide li p"), { y: 0, opacity: 0 });
			gsap.set($(".donate-slide li i"), { scale: 0 });
			gsap.set($(".donate-slide .donate--cta a"), { y: 30, opacity: 0 });

			const donateTL = gsap.timeline()
				.to($(".donate-slide").eq(0).find("p").eq(0), { y: -30, autoAlpha: 1, duration: 0.1 })
				.to($(".donate-slide").eq(0).find("p").eq(1), { y: -30, autoAlpha: 1, duration: 0.1 })

				.to($(".donate-slide").eq(1).find("p").eq(0), { y: -30, autoAlpha: 1, duration: 0.1 })

				.to($(".donate-slide").eq(1).find("li").eq(0).find('i'), { scale: 1, duration: 0.1 })
				.to($(".donate-slide").eq(1).find("li").eq(0).find('p'), { autoAlpha: 1, duration: 0.2 }, "-=0.1")
				.to($(".donate-slide").eq(1).find("li").eq(1).find('i'), { scale: 1, duration: 0.1 })
				.to($(".donate-slide").eq(1).find("li").eq(1).find('p'), { autoAlpha: 1, duration: 0.2 }, "-=0.1")
				.to($(".donate-slide").eq(1).find("li").eq(2).find('i'), { scale: 1, duration: 0.1 })
				.to($(".donate-slide").eq(1).find("li").eq(2).find('p'), { autoAlpha: 1, duration: 0.2 }, "-=0.1")
				.to($(".donate-slide").eq(1).find("li").eq(3).find('i'), { scale: 1, duration: 0.1 })
				.to($(".donate-slide").eq(1).find("li").eq(3).find('p'), { autoAlpha: 1, duration: 0.2 }, "-=0.1")
				.to($(".donate-slide").eq(1).find("li").eq(4).find('i'), { scale: 1, duration: 0.1 })
				.to($(".donate-slide").eq(1).find("li").eq(4).find('p'), { autoAlpha: 1, duration: 0.2 }, "-=0.1")


				.to($(".donate-slide").eq(2).find("p").eq(0), { y: -30, autoAlpha: 1, duration: 0.1 })
				.to($(".donate-slide").eq(2).find("p").eq(1), { y: -30, autoAlpha: 1, duration: 0.1 })
				.to($(".donate-slide").eq(2).find(".donate--cta a").eq(0), { y: -30, autoAlpha: 1, duration: 0.1 })
				.to($(".donate-slide").eq(2).find(".donate--cta a").eq(1), { y: -30, autoAlpha: 1, duration: 0.1 })
				.to($(".donate-slide").eq(2).find(".donate--cta a").eq(2), { y: -30, autoAlpha: 1, duration: 0.1 })
				.to($(".donate-slide").eq(2).find(".donate--cta a").eq(3), { y: -30, autoAlpha: 1, duration: 0.1 })
				.to($("footer"), { autoAlpha: 1, duration: 0.1 })


			ScrollTrigger.create({
				trigger: ".donate",
				animation: donateTL,
				// markers: true,
				start: "top 50%",
				scrub: 1,
				end: "bottom bottom",
				// once: true
			});


			$('.chp').each(function (i) {

				ScrollTrigger.create({
					trigger: $(this),
					markers: false,
					onEnter: function () {
						$('aside nav').attr('class', 'is-active--' + parseInt(i));
					},
					onEnterBack: function () {
						$('aside nav').attr('class', 'is-active--' + i);
					},
					id: 'nav' + i,
					start: "top top",
					end: "bottom bottom"
				});
			});
		},

		videoUnmute: function () {
			$('.video-container').each(function () {

				const $vid = $(this).find('video');
				$(this).find('button').on('click', function () {

					if ($vid.prop('muted')) {
						$(this).addClass('is-muted');
						$vid.prop('muted', false);
					} else {
						$(this).removeClass('is-muted');
						$vid.prop('muted', true);
					}
				});

				$vid.on('inview', function (event, isInView) {
					if (isInView) {
						$vid.get(0).play();
						// console.log('===  main.js [307] PLAY ===', $vid.attr('src') );
					}
					else {
						$vid.get(0).pause();
						$vid.parent().find('button').removeClass('is-muted');
						$vid.prop('muted', true);
						// console.log('===  main.js [307] PAUSE ===', $vid.attr('src') );
					}
				});

			});
		},

		videoLightbox: function () {
			$('.js-play-video').magnificPopup({
				type: 'iframe',
				iframe: {
					markup: '<div class="mfp-iframe-scaler">' +
						'<div class="mfp-close"></div>' +
						'<iframe class="mfp-iframe" allow="autoplay; fullscreen; picture-in-picture" src="//about:blank" frameborder="0" allowfullscreen></iframe>' +
						'</div>',

					srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
				}
			}).on('mfpBeforeOpen', function (obj) {
				// check if mure global sound
				if ($('.toogleMute').hasClass('is-playing')) {
					$('.toogleMute').attr('data-is-playing', 'yes');
					$('.toogleMute').trigger('click');
				}
				else {
					$('.toogleMute').attr('data-is-playing', 'no');
				}
			}).on('mfpOpen', function (obj) {

				// unmuting still pause the video in Chrome = Unmuting failed and the element was paused instead because the user didn't interact with the document before.
				var iframe = document.querySelector('iframe');
				var player = new Vimeo.Player(iframe);
				setTimeout(function () {
					// player.play();
					player.setMuted(false);
				}, 200);
				setTimeout(function () {
					player.setVolume(1);
				}, 1000);

			}).on('mfpAfterClose', function (obj) {
				// close, unmute
				if ($('.toogleMute').attr('data-is-playing') == 'yes') {
					$('.toogleMute').trigger('click');
				}
			});
		},

		/**
		 * inview loading
		 *
		 */
		inviewLazy: function () {
			const chapters = ['chp1', 'chp2', 'js-playSound3', 'chp5', 'chp6', 'chapter-objects', 'donate'];

			chapters.forEach(function (chapter) {

				$('.' + chapter).on('inview', function (event, isInView) {
					if (isInView) {
						if (!$(this).hasClass('is-lazy-loaded')) {
							// load all videos and images
							$('.' + chapter + ' .lazy').each(function () {
								$(this).attr('src', $(this).attr('data-src'));
								if ($(this).is('video')) {
									$(this).attr('playsinline', true);
								}
							});
							$(this).addClass('is-lazy-loaded');
						}
					}
				});

			});
		},
		/**
		 * inview animation
		 *
		 */
		inviewAnimation: function () {
			var self = this;

			$("[class*='ivanim-']").on('inview', function (event, isInView) {
				if (isInView) {
					if (!$(this).hasClass('is-inview')) {
						$(this).addClass('is-inview');
					}
				}
			});

			// inview repeat
			$("[class*='ivanimr-']").on('inview', function (event, isInView) {
				if (isInView) {
					if (!$(this).hasClass('is-inview')) {
						$(this).addClass('is-inview');
					}
				}
				else {
					if ($(this).hasClass('is-inview')) {
						$(this).removeClass('is-inview');
					}
				}
			});
		},
	};

	$(document).ready(function () {
		Site.init();
	})

})(jQuery);



// WEBPACK FOOTER //
// ./src/js/main.js